import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PlatformAvailabilityGuard implements CanActivate {
  constructor(private router: Router, private auth: Auth) {}

  async canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    await this.auth.authStateReady();

    return this.auth.currentUser?.uid
      ? true
      : this.router.createUrlTree(['/logIn'], { queryParams: { 'system-monitoring': true } });
  }
}
